/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadFilesVo
 */
export interface UploadFilesVo {
    /**
     * 文件ID
     * @type {number}
     * @memberof UploadFilesVo
     */
    id?: number;
    /**
     * 文件url
     * @type {string}
     * @memberof UploadFilesVo
     */
    fileUrl?: string;
    /**
     * 原始文件名
     * @type {string}
     * @memberof UploadFilesVo
     */
    fileName?: string;
    /**
     * 场景内容 对应文件夹名
     * @type {string}
     * @memberof UploadFilesVo
     */
    usageType?: string;
    /**
     * 文件类型，存文件扩展名
     * @type {string}
     * @memberof UploadFilesVo
     */
    fileType?: string;
}

/**
 * Check if a given object implements the UploadFilesVo interface.
 */
export function instanceOfUploadFilesVo(value: object): value is UploadFilesVo {
    return true;
}

export function UploadFilesVoFromJSON(json: any): UploadFilesVo {
    return UploadFilesVoFromJSONTyped(json, false);
}

export function UploadFilesVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadFilesVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'usageType': json['usageType'] == null ? undefined : json['usageType'],
        'fileType': json['fileType'] == null ? undefined : json['fileType'],
    };
}

export function UploadFilesVoToJSON(json: any): UploadFilesVo {
    return UploadFilesVoToJSONTyped(json, false);
}

export function UploadFilesVoToJSONTyped(value?: UploadFilesVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fileUrl': value['fileUrl'],
        'fileName': value['fileName'],
        'usageType': value['usageType'],
        'fileType': value['fileType'],
    };
}

